import { DisplayMode } from '@flywire/internal-components/model';

import { ENDPOINTS } from '../../endpoints';

export type PaymentMethodSelectorUrlBuilderParams = {
  recipientId: string;
  amount: number;
  country: string;
  displayMode?: DisplayMode;
};

export const paymentMethodSelectorUrlBuilder = (
  params: PaymentMethodSelectorUrlBuilderParams
): string => {
  const { recipientId, amount, country, displayMode = 'container' } = params;

  return `${ENDPOINTS.paymentMethodSelectorForm}?recipient_id=${encodeURIComponent(recipientId)}&amount=${encodeURIComponent(amount)}&country=${encodeURIComponent(country)}&display_mode=${encodeURIComponent(displayMode)}`;
};
